// =============================================================================
// Sphera Export Types — mirrors backend sphera-export-output-dto
// =============================================================================

export const SPHERA_INSPECTION_TYPES = [
	'VER_E_AGIR',
	'INTERACAO',
	'CARTAO_AMARELO',
] as const

export type SpheraInspectionType = (typeof SPHERA_INSPECTION_TYPES)[number]

export type SpheraIssueCode =
	| 'MISSING_SERVICE'
	| 'MISSING_LOCATION'
	| 'MISSING_FLAG'

export interface SpheraColumn {
	key: string
	/** Header técnico (linha 1 do template) */
	header: string
	/** Rótulo amigável (linha 2 do template) */
	label: string
}

export interface SpheraPreviewRow {
	values: Record<string, string>
	issues: SpheraIssueCode[]
}

export interface SpheraPendingCr {
	id: string
	code: string
	name: string
	branchName: string
}

export interface SpheraPendingBranch {
	id: string
	name: string
}

export interface SpheraPendingCatalog {
	id: string
	name: string
	type: 'KIND' | 'CLASSIFICATION'
}

export interface SpheraPreviewOutput {
	month: string
	columns: SpheraColumn[]
	/** Linhas por arquivo e quantos arquivos o export gera */
	maxRowsPerFile: number
	parts: number
	rows: SpheraPreviewRow[]
	pending: {
		crs: SpheraPendingCr[]
		branches: SpheraPendingBranch[]
		catalog: SpheraPendingCatalog[]
	}
}

export interface SpheraOptionItem {
	id: string
	name: string
	usageCount: number
}

export type SpheraOptionType = 'FLAG' | 'SERVICE'

export interface SpheraOptionsOutput {
	flags: SpheraOptionItem[]
	services: SpheraOptionItem[]
}

export interface SpheraExportParams {
	month: string
	types: SpheraInspectionType[]
	branchId?: string
}

export interface SpheraBranchConfig {
	id: string
	code: string
	name: string
	spheraLocation: string | null
}

export interface SpheraCrConfig {
	id: string
	code: string
	name: string
	branchName: string
	spheraService: string | null
}

export interface SpheraSettings {
	incidentIdPrefix: string
	maxRowsPerFile: number
	fixed: {
		typeOfLocation: string
		potentialRisk: string
		owner: string
		imported: string
		formId: string
		isCommitted: string
		closed: string
		status: string
		eventType: string
	}
	observationType: {
		cartaoAmarelo: string
		interacaoCongratulated: string
		interacaoOriented: string
		vereAgirStopAndFix: string
		vereAgirFixAndContinue: string
	}
	interacaoActionText: { congratulated: string; oriented: string }
	employeeType: {
		cartaoAmarelo: string
		noGroup: string
		ssma: string
		other: string
		ssmaClusterName: string
	}
}

export interface SpheraSettingsOutput {
	settings: SpheraSettings
	columns: SpheraColumn[]
	examples: Partial<Record<SpheraInspectionType, Record<string, string>>>
	choices: {
		observationTypes: string[]
		employeeTypes: string[]
		potentialRisks: string[]
	}
}
